import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { motion } from 'framer-motion';
import { API } from '../config';

export const CategoryFilter = ({ selectedCategory, onSelectCategory }) => {
  const [categories, setCategories] = useState([]);

  useEffect(() => {
    fetchCategories();
  }, []);

  const fetchCategories = async () => {
    try {
      const { data } = await axios.get(`${API}/categories`);
      setCategories(['All', ...data]);
    } catch (error) {
      console.error('Failed to fetch categories:', error);
    }
  };

  return (
    <div className="flex overflow-x-auto snap-x snap-mandatory hide-scrollbar gap-3 pb-2">
      {categories.map((category) => {
        const isActive = (selectedCategory === category || (!selectedCategory && category === 'All'));
        return (
          <motion.button
            key={category}
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
            onClick={() => onSelectCategory(category === 'All' ? null : category)}
            className="px-6 py-2.5 rounded-full whitespace-nowrap font-medium transition-all duration-300 snap-start backdrop-blur-xl"
            style={{
              background: isActive ? '#D4AF37' : 'rgba(255, 255, 255, 0.05)',
              border: `1px solid ${isActive ? '#D4AF37' : 'rgba(255, 255, 255, 0.1)'}`,
              color: isActive ? '#080C0A' : '#F8FAF9'
            }}
            data-testid={`category-filter-${category.toLowerCase()}`}
          >
            {category}
          </motion.button>
        );
      })}
    </div>
  );
};